<template>
  <div v-if="banner.picUrl" class="banner">
    <img :class="{ 'mouse': banner.jumpUrl }" @click="jumpUrl(banner)" :src="banner.picUrl" width="100%" :alt="banner.name" />
  </div>
</template>
<script>
export default {
  name: 'nyBanner',
  props: {
    banner: {
      type: Object,
      default:  () => {}
    }
  }
}
</script>
<style scoped>
.banner {
  height: auto;
  overflow: hidden;
  width: 100%;
}
.banner img {
  vertical-align: middle;
}
@media screen and (max-width: 800px) {
  .banner {
    display: none;
  }
}
</style>
